import React, { Component } from 'react'
import TopBar from '../../components/TopBar'
import BottomBar from '../../components/BottomBar'
import './Kontakt.css'
import '../styles.css'

const barnOgUngeUrl = 'https://bfk.no/tjenester/skole-og-opplaring/ombudet-for-barn-og-unge'
class Kontakt extends Component {

  render() {

    return (
      <div className="OuterContainer">
        <TopBar activePage={'Kontakt'} />
        <div className="Container-cinderella" style={{ paddingLeft: '20px', paddingRight: '20px' }} >
          <div className="Row Center-content">
            <div className="Column Width-940">
              <div className="Empty-space-92" />
              <div className="Kontakt-title">
                Kontakt
              </div>
              <div className="Kontakt-media-query">
                <div className="Empty-space-25" />
              </div>
              <div className="Kontakt-box-container">
                <div className="Kontakt-text-type1">
                  For spørsmål om det faglige innholdet for dialogdukene om foreldre som digitale rollemodeller, ta kontakt med: 

                                  </div>
                <div className="Kontakt-text-type2">
                  <span> Ombudet for barn og unge i Akershus, Buskerud og Østfold
              </span>
            </div>
            <div className="Kontakt-text-type3">
              <a
                style={{
                  color: '#295F75',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
              target="_blank"
                href={barnOgUngeUrl}
              >
{barnOgUngeUrl}
              </a>
            </div>
            <a
                href={barnOgUngeUrl}
              target="_blank"
            >

              <img src={require('./static/Ombudet_logo(mørk) 1.png')} alt="" style={{ paddingTop: '9px', cursor: "pointer" }} />
            </a>
          </div>
          <div className="Empty-space-31" />
          <div className="Kontakt-box-container">
            <div className="Kontakt-text-type1">
For spørsmål om det faglige innholdet for Stjernekolonien, ta kontakt med: 

            </div>
            <div className="Kontakt-text-type2">
Medietilsynet
            </div>
            <div className="Kontakt-text-type3">
              <a
                style={{
                  color: '#295F75',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              href="https://www.medietilsynet.no/om-medietilsynet/organisasjon/kontaktskjema/"
              target="_blank"
              >

                https://www.medietilsynet.no/om-medietilsynet/organisasjon/kontaktskjema/
              </a>
            </div>
            <a
              href={'https://www.medietilsynet.no/'}
              target="_blank"
            >

              <img src={require('./static/medietilsynet.png')} alt="" style={{ paddingTop: '9px', cursor: "pointer" }} />
            </a>
          </div>
          <div className="Empty-space-31" />
          <div className="Kontakt-box-container">
            <div className="Kontakt-text-type1">
              For spørsmål om metode, ta kontakt med:
            </div>
            <div className="Kontakt-text-type2">
              Specifique Norge AS
            </div>
            <div className="Kontakt-text-type3">
              <a
                style={{
                  color: '#295F75',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}

              href={'http://www.specifique.no'}
              target="_blank"
              >
http://www.specifique.no
              </a>
            </div>
            <a
              href={'http://www.specifique.no'}
              target="_blank"

            >
              <img src={require('./static/specifique.png')} alt="" style={{ paddingTop: '13px', cursor: "pointer" }} />
            </a>
          </div>
          <div className="Empty-space-55" />
        </div>
      </div>
        </div >
      <BottomBar />
      </div> 
    ) 
  
  }
}
export default Kontakt



// WEBPACK FOOTER //
// ./src/pages/Kontakt/index.js